import { LayoutGrid } from "lucide-react";
import type { JSX, ReactNode } from "react";

import type { AppDescriptorDTO } from "../api/types.js";
import { AppSidebar } from "./AppSidebar.js";
import { useModalFocus } from "./useModalFocus.js";

export function AppDrawer({ apps, moduleSidebar, onClose, onGrid, onReorder }: {
  apps: AppDescriptorDTO[];
  moduleSidebar?: ReactNode;
  onClose: () => void;
  onGrid: () => void;
  onReorder: (order: string[]) => void;
}): JSX.Element {
  const panel = useModalFocus(onClose);
  return (
    <div className="fixed inset-0 z-40 lg:hidden">
      <button type="button" aria-label="Bereiche schließen" onClick={onClose}
        className="absolute inset-0 bg-black/40" />
      <div ref={panel} role="dialog" aria-modal="true" aria-label="Navigation" tabIndex={-1}
        className={moduleSidebar ? "absolute inset-y-0 left-0 flex w-[min(90vw,22rem)] overflow-hidden border-r border-line bg-surface-raised shadow-2xl" : "absolute inset-y-0 left-0 flex w-16 overflow-hidden border-r border-line bg-surface-raised shadow-2xl"}>
        <div className="flex w-16 shrink-0 flex-col items-center overflow-y-auto border-r border-line px-1 py-2 pb-[calc(theme(spacing.2)+env(safe-area-inset-bottom))] pl-safe-left pt-[calc(theme(spacing.2)+env(safe-area-inset-top))]">
          <button type="button" onClick={onGrid} aria-label="Alle Apps anzeigen"
            className="mb-2 flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-ink-muted hover:bg-surface-sunken hover:text-ink">
            <LayoutGrid className="h-5 w-5" />
          </button>
          <AppSidebar apps={apps} variant="icons" onNavigate={onClose} onReorder={onReorder} />
        </div>
        {moduleSidebar ? <aside className="min-w-0 flex-1 overflow-y-auto p-3 pb-[calc(theme(spacing.3)+env(safe-area-inset-bottom))] pt-[calc(theme(spacing.3)+env(safe-area-inset-top))]">{moduleSidebar}</aside> : null}
      </div>
    </div>
  );
}
